var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionChangeOvertimeFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.12 16.132A3.002 3.002 0 0016 19c0 .941.436 1.778 1.115 2.327l.137-1.377.497.049.498.05-.295 2.954H17.5L14.998 23l.003-1 1.36.002A3.986 3.986 0 0115 19.001l.005-.207a4.004 4.004 0 012.82-3.62l.295.958zm4.88-.133l-1.357-.001a4.002 4.002 0 01-1.464 6.825l-.294-.956A3.003 3.003 0 0022 19a2.99 2.99 0 00-1.115-2.33l-.137 1.379-.497-.05-.498-.049.295-2.95H23v.999z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5.67c3.666 2.935 6.172 7.347 6.47 12.33a5.97 5.97 0 00-3.462 1.122 13.94 13.94 0 00-.588-3.962c-1.02 1.37-2.85 2.22-4.62 2.58-1.76.36-2.81 1.5-2.81 3.12 0 1.74 1.44 3.14 3.22 3.14.841 0 1.631-.219 2.32-.6a5.977 5.977 0 00.549 3.172A7.998 7.998 0 013 14a13.763 13.763 0 013.23-8.89l-.03.36c0 2.06 1.56 3.73 3.63 3.73 2.059 0 3.41-1.67 3.41-3.73 0-2.15-.741-4.8-.741-4.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionChangeOvertimeFill);
export default __webpack_public_path__ + "3210e2ddf6737494e2416e9ad4e39c77.svg";
export { ForwardRef as ReactComponent };